module.exports = __webpack_public_path__ + "img/10f1.d6ec3ff4.jpg";